import React from 'react';
import { useTranslation } from 'react-i18next';
import ReadingLevelChart from './ReadingLevelChart';
import CulturalSelectionsChart from './CulturalSelectionsChart';
import ClassSizeChart from './ClassSizeChart';
import GradeLevelChart from './GradeLevelChart';
import EnrollmentTimelineChart from './EnrollmentTimelineChart';
import './Charts.css';

const Charts: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="charts-dashboard">
      <div className="charts-header">
        <h2>{t('charts.title')}</h2>
        <p>{t('charts.subtitle')}</p>
      </div>
      
      <div className="charts-grid">
        <ReadingLevelChart />
        <CulturalSelectionsChart />
        <ClassSizeChart />
        <GradeLevelChart />
        <EnrollmentTimelineChart />
      </div>
    </div>
  );
};

export default Charts;
